module.exports = __webpack_public_path__ + "media/images/number_23-f91dd269e4f4c8f2af8919c84a1edb59.png";